import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    data-slot="switch"
    className={cn(
      "ui-switch peer focus-visible:ring-ring focus-visible:ring-offset-background data-[state=unchecked]:bg-muted-foreground/45 data-[state=checked]:bg-primary inline-flex h-6 min-h-6 w-11 min-w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors hover:brightness-95 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none active:brightness-90 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:brightness-100 motion-reduce:transition-none forced-colors:border forced-colors:border-[ButtonBorder]",
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      data-slot="switch-thumb"
      className={cn(
        "ui-switch__thumb bg-background pointer-events-none block h-5 w-5 rounded-full shadow-sm ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0 motion-reduce:transition-none rtl:data-[state=checked]:-translate-x-5 forced-colors:bg-[ButtonText]",
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
